import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClose", "tourData", "tourId"];
import PropTypes from 'prop-types';
import { Fragment, useEffect } from 'react';
import PortalIdParser from 'PortalIdParser';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import H5 from 'UIComponents/elements/headings/H5';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UITile from 'UIComponents/tile/UITile';
import { useTourTrackingMethod } from 'ui-shepherd-react/contexts/TourTrackingContext';
import Confetti from '../Confetti';
import { getUserGuideUrl } from '../../constants/URL';
import { parseReturnUrl } from '../../util/urlUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OnboardingTourFinishModal = props => {
  const {
      onClose,
      tourData,
      tourId
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    recommendNextTour,
    returnToUrlOverrides,
    i18nPrefix
  } = tourData;
  const trackTourViewFinishModal = useTourTrackingMethod('trackTourViewFinishModal');
  useEffect(() => {
    if (!trackTourViewFinishModal) {
      return;
    }
    trackTourViewFinishModal(tourId);
  }, [tourId, trackTourViewFinishModal]);
  let recommendedTourLink;
  let recommendedTourLinkClassName = 'm-top-4';
  if (recommendNextTour && recommendNextTour.ctaLink) {
    recommendedTourLink = recommendNextTour.ctaLink.replace('%portalId%', String(PortalIdParser.get()));
    const {
      ctaClassName
    } = recommendNextTour;
    if (ctaClassName) {
      recommendedTourLinkClassName = `${recommendedTourLinkClassName} ${ctaClassName}`;
    }
  }
  return /*#__PURE__*/_jsxs(UIModal, Object.assign({}, rest, {
    className: "m-top-0",
    use: "conversational",
    width: 550,
    children: [/*#__PURE__*/_jsx(Confetti, {}), /*#__PURE__*/_jsx(UIDialogHeader, {
      className: "text-center",
      children: /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx(H4, {
        children: isValidI18nKey(`onboarding-tours-${i18nPrefix}.finishModal.title`) ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: `onboarding-tours-${i18nPrefix}.finishModal.title`
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboarding-tours-modal.finish.title"
        })
      }), recommendNextTour && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "onboarding-tours-modal.finish.recommendTour"
          })
        }), /*#__PURE__*/_jsxs(UITile, {
          className: "m-x-6 m-top-3 p-x-10 p-y-6 text-left",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(H5, {
              children: recommendNextTour.title
            }), /*#__PURE__*/_jsx("span", {
              children: recommendNextTour.text
            })]
          }), /*#__PURE__*/_jsx(UIButton, {
            className: recommendedTourLinkClassName,
            href: returnToUrlOverrides ? parseReturnUrl(returnToUrlOverrides.returnToUrl) : recommendedTourLink,
            size: "sm",
            use: "primary",
            children: recommendNextTour.cta
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      align: "center",
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "onboarding-tour-finish-modal-finish-button",
        href: returnToUrlOverrides ? parseReturnUrl(returnToUrlOverrides.returnToUrl) : getUserGuideUrl(),
        size: recommendNextTour ? 'sm' : undefined,
        use: recommendNextTour ? undefined : 'primary',
        children: returnToUrlOverrides ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: `onboarding-tours-${i18nPrefix}.returnToUrlOverrides.text`
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "onboarding-tours-modal.finish.cta"
        })
      })
    })]
  }));
};
OnboardingTourFinishModal.propTypes = {
  onClose: PropTypes.func,
  step: PropTypes.object,
  tourData: PropTypes.object,
  tourId: PropTypes.string
};
export default OnboardingTourFinishModal;